export default __webpack_public_path__ + "static/OpenSans-Regular-9ae9233a231c8f3265141814922bc128.woff";